module.exports = __webpack_public_path__ + "img/chip4.a1a15854.png";